import React, { useEffect } from 'react';
import { arrayOf, string, object, func } from 'prop-types';
import { NotableClientsAbout } from '@fiverr-private/seller_presence';
import WithImpressions from '../../../shared/withImpressions';
import { NOTABLE_CLIENTS_ORIGIN } from '../../../shared/NotableClients/constants';
import './style.scss';

const CLASS_NAME = 'notable-clients-about-local';
const SUB_CLASS_NAME = 'client-list';

const NotableClientsAboutLocal = ({ notableClients, sellerName, profilePhoto, collectImpressions, impressionRef }) => {

    useEffect(() => {
        collectImpressions();
    }, [collectImpressions]);

    const aboutProps = {
        notableClients,
        seller: {
            name: sellerName,
            profilePhoto
        },
        origin: NOTABLE_CLIENTS_ORIGIN
    };

    return (
        <div className="notable-clients-about-local m-t-16 p-t-16" ref={impressionRef}>
            <NotableClientsAbout {...aboutProps}/>
        </div>
    );
};

const impressionConfig = {
    DOMSelector: `.${CLASS_NAME} > .${SUB_CLASS_NAME}`,
    eventKey: 'notable_client_below_the_fold_component_is_shown'
};

NotableClientsAboutLocal.propTypes = {
    notableClients: arrayOf(object),
    sellerName: string,
    profilePhoto: string,
    collectImpressions: func,
    impressionRef: object
};

export { NotableClientsAboutLocal };
export default WithImpressions(NotableClientsAboutLocal, impressionConfig);
